import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-12 px-0" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-kalender",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "my-2" }
const _hoisted_5 = { class: "mb-2 mt-0" }
const _hoisted_6 = { class: "d-flex justify-content-end" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-editieren",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_link_add_element = _resolveComponent("link-add-element")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_calendar_month_selector = _resolveComponent("calendar-month-selector")!
  const _component_calendar_monthly = _resolveComponent("calendar-monthly")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.timeSlotList.title' )), 1)
      ])
    ]),
    _createVNode(_component_link_back, {
      to: "/rooms",
      i18nMessage: "common.backToOverview"
    }),
    _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.room.name), 1),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.room.description), 1),
    _createVNode(_component_loading_container, { state: _ctx.state }, {
      default: _withCtx(() => [
        _createVNode(_component_link_add_element, {
          i18nMessage: "common.timeSlot.add",
          to: { name: 'admin-time-slot-add', params: { id: _ctx.room.id }, query: { 'fromSearch': 'y'} },
          class: "d-flex justify-content-end mb-2"
        }, null, 8, ["to"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            class: "d-flex align-items-center no-underline text-positive",
            to: {
            name: 'admin-time-slot-edit-multi-capacity',
            params: { 'roomId': _ctx.roomId },
            query: { 'fromSearch': 'y' }
          }
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.timeSlotList.multiEditCapacity')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]),
        _createVNode(_component_calendar_month_selector, {
          calendarForDay: _ctx.calendarForDay,
          onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeMonth($event))),
          class: "mt-3"
        }, null, 8, ["calendarForDay"]),
        _createVNode(_component_calendar_monthly, {
          room: _ctx.room,
          days: _ctx.days,
          onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onTimeSlotClicked($event))),
          adminDashboard: true
        }, null, 8, ["room", "days"])
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}